module.exports = function (string) {
  return string.replace(/\s+/, ' ')
}
